'use strict';

var React = require('react');

module.exports = React.createClass({
    displayName: 'exports',


    getDefaultProps: function getDefaultProps() {
        return {
            item: '',
            label: '',
            select: false,
            onListItemClicked: function onListItemClicked(item, event) {}
        };
    },

    handleClick: function handleClick(item, event) {
        this.props.onListItemClicked(item, event);
    },

    render: function render() {
        return React.createElement(
            'div',
            { onClick: this.handleClick.bind(this, this.props.item), className: "clickable " + (this.props.selected ? 'selected' : '') },
            this.props.label
        );
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/Dropdown/DropdownStringItem.js
// module id = 459
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26